import React from 'react';
import BetLine from './BetLine';
// import BetSummary from './BetSummary';
import { useBetContext } from '../context/BetContext';
import { InternalGroupedEvent,Bet } from '../types';
import { isClosedOrSuspended } from '../utils/utils';
interface Props {
  group: InternalGroupedEvent;
  // calculatedOdds: number;
}

const EventBets: React.FC<Props> = ({ group, /* calculatedOdds */ }) => {
  const { config } = useBetContext();
  const closedOrSuspended = isClosedOrSuspended(group);
  return (
    <>
      {group.Selections.map((bet: Bet, index) =>
        bet.addOnError ? (
          <BetLine
            key={bet.id}
            bet={bet}
            displayRemoveIcon={group.Selections.length > 1 && !config.viewOnly}
            showLine={index < group.Selections.length - 1}
            flashOddsInterval={config.oddsFlashInterval || 5000}
            closedOrSuspended={closedOrSuspended}
          />
        ) : (
          <div key={`placeholder-${bet.id}`} className="bet-placeholder">
            
          </div>
        )
      )}
      {/* commenting out as per design */}
      {/*<BetSummary  calculatedOdd={calculatedOdds} bets={group.Selections} />*/}
    </>
  );
};

export default EventBets;
